import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-user",
  "use": "icon-user-usage",
  "viewBox": "0 0 100 125",
  "content": "<symbol viewBox=\"0 0 100 125\" id=\"icon-user\">\r\n\t<path d=\"M50,97c25.9,0,47-21.1,47-47S75.9,3,50,3S3,24.1,3,50S24.1,97,50,97z M49.9,24.1c9.8,0,17.7,7.9,17.7,17.7\r\n\t\ts-7.9,17.7-17.7,17.7s-17.7-7.9-17.7-17.7C32.2,32.1,40.2,24.1,49.9,24.1z M21.8,82.4c0.4-1.1,1-2.3,1.8-3.3\r\n\t\tc6.6-8.8,16.2-14.3,26.7-14.3S70.4,70.3,77,79.1c0.7,0.9,1.2,1.8,1.6,2.8C71.1,88.8,61,93,50,93C39.2,93,29.4,89,21.8,82.4z\" />\r\n\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/general/svg/user.svg
// module id = OBau
// module chunks = 0